<!-- =========================================================================================
  File Name: SessionAdd.vue
  Description: Session Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div class="page-wrap-area">
    <h3>Video Uploader</h3>
    <p>You can upload a video and continue to work on the CMS while it's transcoded and ready to stream.</p>
    <div class="video-upload-wrap mt-5">
      <div class="drag-n-drop" style="text-align: center;">
        <span style="display: block"><feather-icon
        class="sm:inline-flex cursor-pointer p-0 m-0"
        icon="UploadIcon"
        /></span>
        <input type="file" ref="upload_lsvideo_input" @change="upload_start" accept="video/*" />
        <h4 class="mt-4">Drag and Drop or Browse</h4>
        <p>(Allowed File Types: .mp4, .mov, .avi, .wmv) & Max Size 250 MB</p>
      </div>
    </div>
    <div class="vx-col md:w-1/1 w-full my-3 " >
      {{message}}
    </div> 
    <div class="vx-col md:w-4/12 my-3 ">
      <div v-show="uploading" class="uploading-progressbar mt-5">
        <h4>Uploading <span></span></h4>
        <vs-progress indeterminate color="primary" class="mt-3"></vs-progress>
      </div>
      <div v-show="transcoding" class="transcoding-progressbar mt-5">
        <h4>Transcoding <span>{{transcodePercent}}%</span></h4>
        <vs-progress indeterminate color="primary" class="mt-3"></vs-progress>
      </div>
    </div>
  </div>

  <!--<vx-card>                       
   <div class="vx-row">
    <div class="vx-col md:w-1/2 w-full my-3 " >
      <input type="file" ref="upload_lsvideo_input" @change="upload_start" accept="video/*" />    
    </div> 

    <div class="vx-col md:w-1/1 w-full my-3 " >
      {{message}}
    </div> 
   </div>                   
  </vx-card>-->

</template>



<script>

import moment from 'moment-timezone';
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";

import ls from "@/common/localStorage"

let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate")
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate")
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ")
let Session_scheduleInUTC = ls.getSessionValueByKey("Session_scheduleInUTC")
let Session_StartDate_UTC = ls.getSessionValueByKey("Session_StartDate_UTC")
var vm
var interval
export default {  
  components: {    
  },
  
  data() {
    return {
      SessionId: this.$route.params.SessionId,
      TypeId: this.$route.params.TypeId,
      session_data: null,
      transcodePercent: 0,
      getpercentAttempt: 0,
      uploading: false,
      transcoding: false,
      message: null
    }
  },  
  watch: {
    activeTab() {
      //this.fetch_session_data(this.$route.params.sessionId);
    }
  },  
  methods: {   
  upload_start(input){
    vm.message = ""
    this.$store.dispatch('sessionManagement/updateSessionTypeDetail', { id: vm.SessionId, TypeID: vm.TypeId})
    if(vm.TypeId == 1)
    {
      vm.upload_Odvideo(input)
    }
    else if(vm.TypeId == 2)
    {
      vm.upload_lsvideo(input)
    }
    else
    {
      vm.message = "Please select session type"
    }    
  } ,
    upload_Odvideo(input){
      if (input.target.files.length) { 
        for(var i = 0; i < input.target.files.length ; i++) {
          const file = input.target.files[i]
          const metadata = {
            'contentType': file.type
          }     
          //console.log(file)
          let  filename = file.name
          filename = filename.split('.').pop();
          //console.log(filename) 
          const validImageTypes = ['mp4', 'mov', 'avi', 'wmv']
          if (!validImageTypes.includes(filename)) {
            alert('Only files allowed.')
            return false
          }
          if(/\s/.test(file.name))
          {
            alert('Space not allowed in file name.')
            return false
          }
          let FileSize = file.size / 1024 / 1024;
          if(FileSize > 250)
          {
            alert("Uploaded file size exceeds 250 MB");
            return false;
          }
          
          this.$vs.loading();
          this.uploading = true;
          let sessionId = this.SessionId 
        this.$store
        .dispatch("sessionManagement/uploadVideo", {
          file: file,
          filename: file.name   ,
          contentType: file.type,
          sessionId:  sessionId    
        })
        .then((res) => {
          //this.session_data.ODVideoLengthMinutes = 5;
          //this.session_data.ODVideoURL = res.url;
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Video",
            text: "Video Uploaded Successfully."
          });

          this.uploading = false;
          vm.message = "Video Uploaded Successfully."
          this.$vs.loading.close();
          })
        }        
      }
    },
    
    upload_lsvideo(input){
      if (input.target.files.length) { 
        for(var i = 0; i < input.target.files.length ; i++) {
          const file = input.target.files[i]
          const metadata = {
            'contentType': file.type
          }     
          //console.log(file)
          let  filename = file.name
          filename = filename.split('.').pop();
          //console.log(filename) 
          const validImageTypes = ['mp4', 'mov', 'avi', 'wmv']
          if (!validImageTypes.includes(filename)) {
            alert('Only files allowed.')
            return false
          }
          if(/\s/.test(file.name))
          {
            alert('Space not allowed in file name.')
            return false
          }
          let FileSize = file.size / 1024 / 1024;
          if(FileSize > 250)
          {
            alert("Uploaded file size exceeds 250 MB");
            return false;
          }
          
          this.$vs.loading();
          this.uploading = true;
          let sessionId = this.SessionId 
        this.$store
        .dispatch("sessionManagement/uploadlsVideo", {
          file: file,
          filename: file.name   ,
          contentType: file.type,
          sessionId:  sessionId ,
          scheduleInUTC: JSON.parse(Session_scheduleInUTC),
          Session_StartDate_UTC: Session_StartDate_UTC
        })
        .then((res) => {
          //this.session_data.LSVideoLengthMinutes = 5;
          //this.session_data.LSVideoURL = res.url;
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Video",
            text: "Video Uploaded Successfully."
          });
          vm.message = "Video Uploaded Successfully. Waiting for Transcode."
          this.uploading = false;   
          this.$vs.loading.close();
          interval = setInterval(function(){               
              vm.checkPercent()
          }, 10000);

          })
        }        
      }
    },
    checkPercent(){
      let sessionId = this.SessionId 
      this.message = "";
      this.transcoding = true;
      let requestData = {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                    "sessionId": sessionId                    
                }
        this.$store
        .dispatch("sessionManagement/getLiveSessionInfo", {          
          requestData:  requestData
        })
        .then((res) => {
          console.log(res)
          this.transcodePercent = res.data.data.transcodePercent ? res.data.data.transcodePercent : this.transcodePercent       
          //this.message = "Video Transcoded : " + res.data.data.transcodePercent + "%"
          this.getpercentAttempt = this.getpercentAttempt + 1;
          if(res.data.data.transcodePercent == 100)
          {
            this.transcodePercent = res.data.data.transcodePercent
            this.transcoding = false;
            this.message = "Video Transcoding done"
            clearInterval(interval);
          }
          else if(res.data.data.transcodePercent == 0 && this.getpercentAttempt == 10)
          {
            this.transcoding = false;
            this.message = "Something went wrong! Video Transcoded : " + res.data.data.transcodePercent + "%"
            clearInterval(interval);
          }
          else
          {
          }
        })
    },
    GetTimeByZone : function(strDateTime, timeZone)
    {
        strDateTime = moment(strDateTime).format('YYYY-MM-DD HH:mm')
        var strtDate = moment.tz(strDateTime, timeZone);
        strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);      
        return strtDate._d;     
    },
    SetTimeByZone : function(strDateTime, timeZone)
    {  
        var date = moment.tz(strDateTime, timeZone).format('MM/DD/YYYY HH:mm');
        return date
    },

  },  
  created() {
   vm = this
    //debugger;
    // Register Module SessionManagement Module
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    
  }
};
</script>